export default __webpack_public_path__ + "static/media/central_andes_1_15.15a6ba76.JPG";